import getLogger, { ILogger } from '../Core/Logger';
import { Actions } from '../State/Actions/Actions';
import { IGameState, IStateSubcriber } from '../State/Store/store';
import { StateUtils } from './StateUtils';
import Core from '../Core/Core';

const logger: ILogger = getLogger('[MESSAGES]:');

export default class Messages {
    private readonly messagesListener: IStateSubcriber<any>;
    private readonly listeners: Array<IStateSubcriber<any>>;

    constructor() {
        this.messagesListener = {
            callback: this.handleMessages.bind(this),
            selector: (state: IGameState) => state,
            id: 'messages-listeners',
        };

        this.listeners = [this.messagesListener];
        Core.store.addListener(this.listeners);
    }

    public cleanUp() {
        Core.store.removeListener(this.listeners);
    }

    private handleMessages(state: IGameState, pre: IGameState) {
        const player = state.StatePlayer;
        const newMapUnlocked = StateUtils.newMapUnlocked(player);
        if (newMapUnlocked) {
            return;
        }
        this.handleOptIn(state, pre);
    }

    private handleOptIn(state: IGameState, pre: IGameState) {
        if (state.StateLevel.levelIndex !== pre.StateLevel.levelIndex) {
            if (
                !state.StateSocial.optInShown &&
                !state.StateSocial.optInRequired &&
                !state.StateSocial.nativeOptInRequired
            ) {
                Core.sdk.bots
                    .canSubscribeBots()
                    .then(res => {
                        logger.debug(' CAN SUBSCRIBE TO BOTS:' + res);
                        if (!res) {
                            return;
                        }
                        if (res === 'no bots here') {
                            return;
                        }
                        /*         if (
                            state.StatePlayer.lastLevelIndex >= 3 &&
                            !state.StateSocial.optInRewardDate
                        ) {
                            Core.store.dispatch(Actions.optInPrompt());
                        } else {*/
                        Core.store.dispatch(Actions.nativeOptInPrompt());
                        // }
                    })
                    .catch(err => {
                        logger.debug(' error with bot subscribe: ' + err);
                    });
            }
            if (
                !state.StatePlayer.optInShortcutShown &&
                !state.StatePlayer.nativeOptInShortcutRequired
            ) {
                if (state.StatePlayer.lastLevelIndex >= 5) {
                    Core.sdk.messages
                        .canCreateShortcut()
                        .then(canCreate => {
                            if (!canCreate) {
                                return;
                            }
                            Core.store.dispatch(Actions.nativeOptInShortcutPrompt());
                        })
                        .catch(err => {
                            logger.debug(' cannot add shortcut: ' + err);
                        });
                }
            }
        }
    }
}
